<template>
  <div v-if="branchRolesData" class="">
    <div class="table-container">
      <table class="my-table">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("description") }}</th>
            <th>{{ $t("info") }}</th>
            <th>{{ $t("edit") }}</th>
            <th>{{ $t("delete") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(role, index) in branchRolesData" :key="index">
            <td>{{ ++index }}</td>
            <td>
              {{ isDataExist(role.branchRoleNameCurrent) }}
            </td>
            <td>
              {{ isDataExist(role.branchRoleDescriptionCurrent) }}
            </td>
            <td>
              <button
                v-b-modal.BranchRoleInfo
                class="btn p-0"
                :title="$t('info')"
                @click="setBranchRoleData(role)"
              >
                <img src="@/assets/images/info.svg" class="icon-lg" />
              </button>
            </td>
            <td>
              <router-link
                :to="`/edit-branch-role/${role.branchRoleToken}`"
                :title="$t('edit')"
              >
                <img src="@/assets/images/pencil.svg" class="icon-lg" />
              </router-link>
            </td>
            <td>
              <button
                v-b-modal.BranchRoleDelete
                class="btn p-0"
                :title="$t('delete')"
                @click="setBranchRoleData(role)"
              >
                <img src="@/assets/images/trash.svg" class="icon-lg" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { setDataMultiLang, timeToLang, isDataExist } from "@/utils/functions";

export default {
  name: "CountriesTable",
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["branchRolesData", "branchRoleData"],
  methods: {
    setBranchRoleData(branchRoleData) {
      this.$emit("setBranchRoleData", branchRoleData);
    },
    timeToLang(time) {
      return timeToLang(time, this.language);
    },
    setDataMultiLang(lang, dataAr, dataEn, dataUnd) {
      return setDataMultiLang(lang, dataAr, dataEn, dataUnd);
    },
    isDataExist(data) {
      return isDataExist(data);
    },
  },
  computed: {},
};
</script>

<style lang="scss"></style>
